<!-- Start: Site contacts -->
<div class="admin-users">

  <div class="row">
    <div class="col-12 text-right header-search" style="display: flex; flex-direction: row; align-items: center; justify-content: flex-end; gap: 10px;">
      <div class="admin-search">
        <app-search-input name="keywords" [parentForm]="searchForm"
                          (inputChange)="onSearchInputChanged($event)"></app-search-input>
      </div>

      <app-button text="Site Contact" faIcon="fas fa-plus" variant="info" href="/admin/contact/add"
                  [visible]="authService.hasPermission(Permissions.SiteContactWrite)" />
    </div>
  </div>

  <div class="site-contacts-lists">

    @for (siteContact of results.results; track siteContact.id; let i = $index) {
      <div class="site-contact">
        <div class="site-contact__head">
          <div class="site-contact__head__left">
            <div class="site-contact__name__state">
              <span class="site-contact__name">{{ siteContact.firstname + ' ' + siteContact.lastname }}</span>
              <span class="badge" [ngClass]="{'badge-success': siteContact.isActive, 'badge-warning': !siteContact.isActive}">{{ siteContact.isActive ? 'Active' : 'Inactive' }}</span>
            </div>

            <div class="site-contact__email">
              <i class="far fa-envelope"></i>
              <span>{{ siteContact.email }}</span>
            </div>

            <div class="site-contact__registration_sent">
              <button class="btn btn-slim btn-primary" (click)="sendPatientRegistrationMail(siteContact.id, i)" *ngIf="authService.hasPermission(Permissions.SendSiteContactRegistrationLink)">
              <span *ngIf="buttonProcessing[i]">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </span>
                <span *ngIf="!buttonProcessing[i]">
                @if (siteContact.patientRegistrationCode) {
                  Resend Patient Registration Link
                } @else {
                  Send Patient Registration Link
                }
              </span>
              </button>

              @if (siteContact.patientRegistrationCode) {
                <span class="registration-sent">Registration Link Sent</span>
              }
            </div>
          </div>

          @if (siteContact.sites.length > 0) {
            <div class="site-content__head__trials">
              <table>
                <thead>
                <tr>
                  <th>Blinded</th>
                  <th>Trial</th>
                  <th>Site</th>
                </tr>
                </thead>
                <tbody>
                  @for (site of siteContact.sites; track site.id) {
                    <tr>
                      <td style="text-align: center">
                        @if (site.blinded) {
                          <i class="far fa-check"></i>
                        } @else {
                          <i class="far fa-times"></i>
                        }
                      </td>
                      <td>{{ site.trialLabel }}</td>
                      <td>{{ site.irgSiteId ? site.irgSiteId : '-' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          <div class="site-contact__head__right">
            <a [routerLink]="['/admin/contact/edit', siteContact.id]" class="btn btn-secondary btn-slim btn-auto-width" *ngIf="authService.hasPermission(Permissions.SiteContactWrite)">Edit</a>
            <a (click)="onDeleteSiteContact(siteContact.id)" class="btn btn-outline btn-slim btn-auto-width" data-toggle="modal" data-target="#delete-user-modal" *ngIf="authService.hasPermission(Permissions.SiteContactWrite)">Delete</a>
          </div>
        </div>
      </div>
    }

  </div>

</div>

<app-pagination [currentPage]="results.currentPage" [totalPageCount]="results.totalPageCount" (pageSelected)="onChangePage($event)"></app-pagination>

<div class="no-results inside" *ngIf="!hasResults && dataLoaded">
  <div class="inner">
    <div class="image">
      <img src="assets/img/no-patients.png" alt="No site contacts" />
    </div>
    <div class="content">
      <h2>No Site Contacts</h2>
    </div>
  </div>
</div>
<!-- End: Site contacts -->

<!-- Start: Delete user modal -->
<app-modal #deleteSiteContactModal>
  <div class="modal-header">
    <h2 class="modal-title">Delete Site Contact?</h2>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this site contact?</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="deleteSiteContactModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
      </div>

      <div class="col-6">
        <a (click)="onDeleteConfirmed()" class="btn btn-primary">
          <span *ngIf="siteContactIsBeingDeleted">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span class="sr-only">Loading...</span>
                        </span>
          <span *ngIf="!siteContactIsBeingDeleted">Delete</span>
        </a>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Delete user modal -->
